import { render } from "./GlossaryDefinitionNodeDialog.vue?vue&type=template&id=0c7035d8&scoped=true&ts=true"
import script from "./GlossaryDefinitionNodeDialog.vue?vue&type=script&lang=ts"
export * from "./GlossaryDefinitionNodeDialog.vue?vue&type=script&lang=ts"

import "./GlossaryDefinitionNodeDialog.vue?vue&type=style&index=0&id=0c7035d8&lang=scss&scoped=true"

import exportComponent from "/dati01/var/lib/jenkins/workspace/Sub_Task_Release_CE/knowage-vue/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c7035d8"]])

export default __exports__